export default {
    disabledPanelText: 'rgba(0,0,0,0.25)',
    gray: '#9EADB9',                // Gray
    gray10: 'rgba(158,173,185, 0.1)',
    gray50: 'rgba(158,173,185, 0.5)',
    h1: 'black',
    h2: '#61C1B9',
    h3: '#665EF1',
    inactive: '#9EADB9',
    mainPanelBackground: 'white',   // White
    panelBackground: '#DFE7ED',     // Pale Green
    primary: '#61C1B9',             // Green
    primary10: 'rgba(97,193,185, 0.1)',
    primary50: 'rgba(97,193,185, 0.5)',
    secondary: '#665EF1',           // Purple
    text: 'black',
};


// WEBPACK FOOTER //
// ./src/State/Colours.tsx